const incomingThreadId = (state = null, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default incomingThreadId;